import { DateInput, Select } from 'components'
import moment from 'moment'
import { SearchingSectionProps } from 'pages/Purchase/Register/types/Reference'
import { useEffect } from 'react';
import { useListReference } from '../hooks';

export const SearchingSections = ({ selected, setSelected }: SearchingSectionProps) => {
  const { dataReference, isLoadingReference, refetchReference } = useListReference()
  const dataDelivered = [
    { value: "1", label: "Pending" },
    { value: "2", label: "Part Delivered" },
    { value: "3", label: "Full Delivered" }
  ]

  const sortedSelectReference = dataReference.sort((a, b) => parseInt(b.value) - parseInt(a.value));
  const sortedSelectDelivered = dataDelivered.sort((a, b) => parseInt(b.value) - parseInt(a.value));
  const allOption = { value: "", label: "All" };

  useEffect(() => {
    if(selected?.date_from && selected?.date_end) { refetchReference({ date_from: selected?.date_from, date_end: selected?.date_end}) }

    // eslint-disable-next-line
  }, [selected]) 

  return (
    <section className="lg:flex overflow-x-auto">
        <div className='flex items-center w-[284px] lg:w-[250px]'>
            <div className="label-text pb-1 font-bold pe-2 lg:w-[145px] w-[350px] uppercase">START DATE</div>
            <DateInput
                className="!w-[150px]"
                placeholderText="Date From"
                onChange={(date) => setSelected({ ...selected, date_from: moment(date).format("YYYY-MM-DD")})}
                selected={ selected?.date_from ? moment(selected?.date_from).toDate() : null }
            />
        </div>
        <div className='flex items-center w-[284px] lg:w-[250px] mt-2 lg:mt-0'>
            <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold lg:w-[110px] !w-[550px] uppercase">END DATE</div>
            <DateInput
                className="!w-[150px]"
                placeholderText="Date To"
                onChange={(date) => setSelected({ ...selected, date_end: moment(date).format("YYYY-MM-DD")})}
                selected={ selected?.date_end ? moment(selected?.date_end).toDate() : null }
            />
        </div>
        <div className='flex items-center ml-1 mt-2 lg:mt-0'>
            <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold w-[142px] lg:w-full">REFERENCE</div>
            <Select
                className="w-[150px]"
                placeholder="Select Location"
                isLoading={isLoadingReference}
                value={selected?.referensi !== "" ? [allOption, ...sortedSelectReference].find((item) => item.value?.toString() === selected?.referensi?.toString()) : allOption}
                options={[allOption, ...dataReference]}
                onChange={(e) => setSelected({ ...selected, referensi: e?.value! })}
            />
        </div>
        <div className='flex items-center ml-1 mt-2 lg:mt-0'>
            <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold w-[142px] lg:w-full">DELIVERED</div>
            <Select
                className="w-[150px]"
                placeholder="Select Location"
                value={selected?.delivery_status !== "" ? [allOption, ...sortedSelectDelivered].find((item) => item.value?.toString() === selected?.delivery_status?.toString()) : allOption}
                options={[allOption, ...dataDelivered]}
                onChange={(e) => setSelected({ ...selected, delivery_status: e?.value! })}
            />
        </div>
    </section>
  )
}